import { TabularCopySink } from './tabular.copysink';
import { Metamodel } from 'app/model/base/model';
import { IModel } from 'app/model/base/annotation';
import { AzureMySqlTableDataset } from 'app/model/dataset/azure-mysql-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureMySql.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: [Metamodel.modelFor(AzureMySqlTableDataset)] }
})
export class AzureMySqlSink extends TabularCopySink {
    public static readonly MODEL: IModel;
    constructor(name?: string, description?: string, id?: number) {
        super(name, description, id);
        this.writeBatchSize = 10000;
        this.writeBatchTimeout = '00:00:30';
    }
}
